import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';
import { checkImageFormatSupport } from './utils/formatImageUrls';

// Clear any stale cache on load
if ('caches' in window) {
  caches.keys().then(names => {
    names.forEach(name => {
      caches.delete(name);
    });
  });
}

// Clear localStorage if we detect a stale state
const lastVersion = localStorage.getItem('app_version');
const currentVersion = '1.0.0'; // Update this when deploying new versions
if (lastVersion !== currentVersion) {
  localStorage.clear();
  localStorage.setItem('app_version', currentVersion);
}

// Check image format support immediately on script load
checkImageFormatSupport();

// Also check on DOMContentLoaded to ensure browser has fully initialized
document.addEventListener('DOMContentLoaded', () => {
  checkImageFormatSupport();
  console.log('[App] Image format support detection complete');
});

// Function to handle hydration and rendering
const renderApp = () => {
  const root = document.getElementById('root');
  
  if (!root) {
    console.error('Root element not found!');
    return;
  }

  // Check if the HTML was prerendered with meta tags
  const hasPrerenderedMeta = document.head.querySelector('meta[name="description"]');
  
  // If meta tags exist, use HelmetProvider to take over without replacing them
  const helmetContext = {};

  createRoot(root).render(
    <React.StrictMode>
      <HelmetProvider context={helmetContext}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
};

// Execute rendering
renderApp();